import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { MAX_LETTER_COUNT } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Footer/constants';

import type { Fields } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Footer/types';

export const useValidation = () => {
  const { t } = useTranslation();

  return yup.object<Fields>().shape({
    question: yup
      .string()
      .trim()
      .required(t('GSP.pages.parentHelper.chat.validation.required'))
      .max(
        MAX_LETTER_COUNT,
        t('GSP.pages.parentHelper.chat.validation.max', {
          characters: MAX_LETTER_COUNT,
        }),
      ),
    chatId: yup.string(),
  });
};
